import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
// import moment from 'moment'

import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import style from '@src/pages/Messages/Messages.module.scss'
import { Footer } from '@src/components/Footer/Footer'
import { AppDispatch } from '@src/store/store'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { selectPayIsLoading } from '@src/store/ducks/pay/selectors'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { Button } from '@src/components/Button/Button'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import MessageAccordion from '@src/components/Message/Message'
import { selectMessagesForUser } from '@src/store/ducks/user/selectors'

const PAGE_SIZE = 8

export const Messages = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isLoading = useSelector(selectPayIsLoading)
  const messagesArr = useSelector(selectMessagesForUser)
  const [index, setIndex] = useState(PAGE_SIZE)

  useEffect(() => {
    // dispatch(getMessagesForUser())
    dispatch(setPageTitle('Сообщения | Личный кабинет для абонентов КОСМОС Телеком'))
  }, [dispatch])

  // const messagesArr = [
  //   {
  //     id: 1,
  //     dt: '15.02.2024',
  //     theme: 'Заявление',
  //     message: 'Уважаемый абонент! Заявление на возврат средств получено. Обращаем Ваше внимание, что в соответствии с договором возврат средств осуществляется в течение 30 дней со дня поступления заявления.',
  //     isRead: true,
  //   },
  //   {
  //     id: 21,
  //     dt: '16.02.2024',
  //     theme: 'Уведомление adsdasdasda dsadadasad',
  //     message: 'Дорогой клиент! .',
  //     isRead: false,
  //   },
  //   {
  //     id: 13,
  //     dt: '17.02.2024',
  //     theme: 'Поздравление Поздравление ПоздравлениеПоздравление Поздравление',
  //     message: 'С днем рождения! Желаем вам счастья, здоровья и успехов во всех начинаниях. Пусть этот день будет наполнен радостью и приятными сюрпризами!',
  //     isRead: true,
  //   },
  // ]
  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.messageContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <h2 className={style.mainTitle}>Сообщения</h2>

        <div className={cn(style.detailsBlock, style.detailsBlock)}>
          <div className={style.headerTable}>
            <div className={style.box}>
              <div className={style.date}>Дата</div>
              <div className={style.title}>Тема</div>
            </div>
          </div>
          <Preloader loading={isLoading} center>
            <div className={style.messageBlock}>

              {messagesArr.length ? (
                messagesArr.slice(0, index).map((el) => (
                  <MessageAccordion
                    key={el.id}
                    elem={el.id}
                    date={el.dt}
                    title={el.theme}
                    isRead={el.isRead}
                    description={el.message}
                  />
                ))
              ) : (
                <div className={style.message}>
                  Сообщения отсутствуют.
                </div>
              )}

            </div>
          </Preloader>
        </div>
        {/* {(!!payments.payAndDeb.length && index < payments.payAndDeb.length) && ( */}
        {(messagesArr.length > index) && (

        <div className={style.btnBlock}>
          <Button
            type="secondary"
            onClickFunc={() => setIndex(index + PAGE_SIZE)}
            className={style.sizeBtn}
          >
            Показать больше
          </Button>
        </div>
        )}
      </div>
      <Footer />
    </div>
  )
}
